/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {CVSAssetType} from '@ion/core/src/types/entities';
import {MapLocateIcon} from '@ion/dls/src/icons/MapLocateIcon';
import {navigateToGoogleDirections} from '../../maps/helpers/globeUtils';
import {IconSize} from '../../types/types';
import {TertiaryIconButton, TertiaryIconButtonProps} from './TertiaryIconButton';

export interface NavigateToIconButtonProps extends TertiaryIconButtonProps {
  assetData: CVSAssetType
}

/**
 *
 * @NavigateToIconButton
 *
 * The NavigateToIconButton is a TertiaryIconButton that displays an arrow/locate
 * icon with "Navigate To" text. Icon placement is specified as it would be
 * for the TertiaryIconButton. Other TertiaryIconButton props may also be specified
 * (except "icon" and "label" props, which are fixed).
 *
 * ```typescript
 *
 * import React from 'react';
 * import {NavigateToIconButton} from '@ion/dls/src/components/buttons/';
 *
 * function MyComponent {
 *   return (
 *     <React.Fragment>
 *       <NavigateToIconButton assetData={assetData} iconDirection='left' />
 *        <br />
 *       <NavigateToIconButton assetData={assetData} />
 *     </React.Fragment>
 *   );
 * }
 *
 * ```
 *
 */
export const NavigateToIconButton = (props: NavigateToIconButtonProps) => {
  const {assetData, ...baseProps} = props;

  return (
    <TertiaryIconButton {...baseProps}
      icon={<MapLocateIcon size={IconSize.medium} />}
      label={translate('common:navigateTo')}
      onClick={function(e) {
        e.stopPropagation();
        e.preventDefault();
        navigateToGoogleDirections(assetData);
      }} />
  );
};

export default NavigateToIconButton;
